import styled, { css } from 'styled-components'
import { colors, media, sizes } from 'client/styles'
import { SpecialRequestsBase } from 'src/effects/SpecialRequests/styles.module.css'
import { CancellationPoliciesBase } from 'src/comps/CancellationPolicies/styles'
import { Content, Header, ModalBase, ExternalContent } from 'client/components/Modal/styles'
import {
  BOOKING_CANCELLED,
  BOOKING_CONFIRMED,
  BOOKING_PENDING,
  BOOKING_UNSOLVED,
  BOOKING_ERROR,
} from 'src/constants/voucher'
import { ButtonSimpleBase } from 'src/comps/ButtonSimple/styles'

const bookingConfirmed = css`
  color: ${colors.green};
`

const bookingPending = css`
  color: ${colors.orange};
`

const bookingUnsolved = css`
  color: ${colors.orange};
`

const bookingCancelled = css`
  color: ${colors.red};
`

export const BookingInformationBase = styled.div`
  display: flex;
  flex-direction: column;
  background: ${colors.white};
  padding-block: 20px;
  padding-inline: ${props => (props.isCancelled ? '0' : '20px')};
  ${props => !props.isCancelled && `border: 2px solid ${colors.grey4}`};
  border-radius: 8px;

  height: 100%;
  width: 100%;

  ${Header} {
    background-color: unset;
    position: relative;
  }

  ${ModalBase} {
    overflow-y: scroll;
  }

  ${media.tablet} {
    ${ExternalContent} {
      border-radius: 8px;
      margin-block-end: 8px;
    }
  }

  @media (max-width: ${sizes.tablet - 1}px) {
    & > ${ModalBase} {
      background-color: ${props => props.theme.colors.grey8};
    }
  }
`

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;

  padding-block: 15px;
  padding-inline: 0;

  ${SpecialRequestsBase},
  ${CancellationPoliciesBase} {
    margin-block: 15px;
    margin-inline: 0;
  }

  ${media.desktop} {
    ${SpecialRequestsBase},
    ${CancellationPoliciesBase} {
      margin-block: 0;
      margin-inline: 0;
    }
  }
`

export const VoucherNumberRow = styled(Row)`
  justify-content: flex-start;
`

export const BookingInformationTitle = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 25px;

  color: ${colors.grey1};
`

export const BookingInformationTitleSection = styled.div`
  display: flex;
  flex-direction: column;

  ${Row} {
    align-items: center;
  }
`

export const BookingInformationHeader = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${media.tablet} {
    margin-inline-end: 25px;
    flex-grow: 1;
    width: auto;
    max-width: 550px;
  }

  @media screen and (max-width: ${sizes.desktop - 1}px) {
    max-width: 100%;
    width: 100%;
    margin-inline-end: 0;
  }
`

export const RowSeparator = styled(Row)`
  border-block-end: 1px solid ${colors.grey4};
`

export const RoomInfoRow = styled(Row)`
  justify-content: space-between;
  max-width: 300px;
`

export const BookingInformationSubtitle = styled.div`
  display: flex;
  font-size: 16px;
  line-height: 150%;

  color: ${colors.grey2};
`

export const BookingInformationLabel = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;

  color: ${colors.grey1};
`

export const BookingInformationValue = styled.div`
  font-size: 16px;
  line-height: 150%;

  color: ${colors.grey2};

  span {
    padding-block: 0;
    padding-inline: 10px;
  }
`

export const FeedbackSection = styled.div`
  display: flex;
  flex-direction: column;

  padding-block-start: 20px;
`

export const BookingStatusLabel = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;
  color: ${colors.green};
  padding-inline-end: 8px;
`

export const BookingStatus = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;
  color: ${colors.green};
  padding-inline-end: 8px;
`

export const StatusWrapper = styled.div`
  display: flex;

  ${BookingStatusLabel},
  ${BookingStatus} {
    ${props => props.status === BOOKING_PENDING && bookingPending};
    ${props => props.status === BOOKING_ERROR && bookingPending};
    ${props => props.status === BOOKING_UNSOLVED && bookingUnsolved};

    ${props => props.status === BOOKING_CANCELLED && bookingCancelled};
    ${props => props.status === BOOKING_CONFIRMED && bookingConfirmed};
  }
`

export const RefundRow = styled(Row)`
  justify-content: flex-start;
  ${ButtonSimpleBase} {
    margin-block-start: 8px;
  }

  ${media.tablet} {
    ${ButtonSimpleBase} {
      margin-inline-end: 8px;
    }
  }
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;

  ${CancellationPoliciesBase} {
    margin-block: 15px;
    margin-inline: 0;
  }

  ${media.desktop} {
    ${CancellationPoliciesBase} {
      margin-block-start: 15px;
    }
  }

  @media screen and (max-width: ${sizes.desktop - 1}px) {
    max-width: 100%;
    width: 100%;
  }
`

export const ModalContent = styled.div`
  ${ModalBase} {
    z-index: 14;
  }

  ${Content} {
    overflow: unset;
  }
`
